// extracted by mini-css-extract-plugin
export default {"block":"TicketLog_block__dhbKP"};